import { useQuery } from "@apollo/client";
import { ADMIN_HEALTH_SYNC_MONITORING } from "../graphql";
import type { HealthSyncMonitoringPayload, SyncHealthStatus } from "../types";
import { POLL_INTERVAL_MS } from "../constants";

interface UseHealthSyncMonitoringOptions {
  status?: SyncHealthStatus;
  provider?: string;
  first?: number;
  skip?: number;
  pollInterval?: number;
}

export function useHealthSyncMonitoring(options: UseHealthSyncMonitoringOptions = {}) {
  const {
    status,
    provider,
    first = 50,
    skip = 0,
    pollInterval = POLL_INTERVAL_MS,
  } = options;

  return useQuery<{ adminHealthSyncMonitoring: HealthSyncMonitoringPayload }>(
    ADMIN_HEALTH_SYNC_MONITORING,
    {
      variables: {
        status: status ?? undefined,
        provider: provider ?? undefined,
        first,
        skip,
      },
      fetchPolicy: "cache-and-network",
      pollInterval,
    },
  );
}
